module.exports = __webpack_public_path__ + "media/images/windows_banner@3x-a871edf2ef3b1e1ff134fc7e63b48c59.png";